exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".col-md-2[_v-3f3cba8f]{padding-top:0}@media(max-width:767px){.col-sm-12[_v-3f3cba8f]{padding:20px 15px 0}}@media (max-width:500px){.item-card[_v-3f3cba8f]{width:95%;margin-left:10px}}@media (max-width:998px){.card-item-home[_v-3f3cba8f]:last-child{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-3f3cba8f&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/pages/Product-detail.vue
// module id = 424
// module chunks = 0